/**
 * src/components/pages/PromoDetailPage.js
 *
 * Detalle de una promoción. Lee :id de los params del router,
 * muestra imagen grande, info completa y CTA WhatsApp + Ver negocio.
 */

import '@/styles/promo-detail.css'
import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { promosData, TAG_COLORS } from '@/db/promos.db.js'
import { getById } from '@/db/businesses.db.js'
import { trackClick } from '@/shared/utils/track.js'
import { brandIcons, uiIcons } from '@/shared/brandIcons.js'
import { waLink } from '@/shared/utils/whatsapp.js'

define('PromoDetailPage', ({ params = {} }) => {
    const promo = promosData.items.find(p => p.id === Number(params.id))

    if (promo) trackClick('promo', promo.id)

    if (!promo) {
        return h('div', { className: 'page' },
            c('Header'),
            h('div', { className: 'promo-detail-page' },
                h('div', { className: 'promo-detail__inner' },
                    h('a', { href: '/promociones', className: 'promo-detail__back' }, '← Volver a promociones'),
                    h('p', {}, '404 — Promoción no encontrada.')
                )
            )
        )
    }

    const business = getById(promo.businessId)
    const color    = TAG_COLORS[promo.tag] || { bg: '#f3f4f6', color: '#374151' }

    /* Badge de tag */
    const tagBadge = h('span', { className: 'promo-detail__tag' }, promo.tag)
    tagBadge.style.background = color.bg
    tagBadge.style.color      = color.color

    /* Hero image */
    const heroSection = h('div', { className: 'promo-detail__hero' },
        h('img', {
            src:       promo.image,
            alt:       promo.title,
            className: 'promo-detail__hero-img'
        }),
        tagBadge
    )

    /* Cuerpo */
    const body = h('div', { className: 'promo-detail__body' },
        business
            ? h('a', {
                href:      `/negocio/${promo.businessId}`,
                className: 'promo-detail__business-link',
                innerHTML: uiIcons.store + ' ' + promo.business + ' →' })
            : h('span', { className: 'promo-detail__business-label', innerHTML: uiIcons.store + ' ' + promo.business }),
        h('h1', { className: 'promo-detail__title' }, promo.title),
        h('p',  { className: 'promo-detail__desc' },  promo.description),
        promo.expires
            ? h('span', { className: 'promo-detail__expires' }, `⏳ Válido hasta: ${promo.expires}`)
            : null
    )

    /* Redes sociales de la promo */
    const socialLinks = []
    const waNum = promo.whatsapp || (business && business.whatsapp)
    if (waNum) socialLinks.push(h('a', { href: waLink(waNum), target: '_blank', rel: 'noopener', className: 'promo-detail__social promo-detail__social--wa', innerHTML: uiIcons.whatsapp + ' WhatsApp' }))
    if (promo.facebook) socialLinks.push(h('a', { href: promo.facebook, target: '_blank', rel: 'noopener', className: 'promo-detail__social promo-detail__social--fb', innerHTML: brandIcons.facebook + ' Facebook' }))
    if (promo.instagram) socialLinks.push(h('a', { href: promo.instagram, target: '_blank', rel: 'noopener', className: 'promo-detail__social promo-detail__social--ig', innerHTML: brandIcons.instagram + ' Instagram' }))
    if (promo.tiktok) socialLinks.push(h('a', { href: promo.tiktok, target: '_blank', rel: 'noopener', className: 'promo-detail__social promo-detail__social--tt', innerHTML: brandIcons.tiktok + ' TikTok' }))

    const socialBar = socialLinks.length
        ? h('div', { className: 'promo-detail__socials' }, ...socialLinks)
        : null

    /* CTA */
    const cta = h('div', { className: 'promo-detail__cta' },
        h('div', { className: 'promo-detail__cta-text' },
            h('h3', {}, '¿Te interesa esta promoción?'),
            h('p',  {}, `Contacta a ${promo.business} directamente.`)
        ),
        h('div', { className: 'promo-detail__cta-actions' },
            waNum
                ? h('a', {
                    href:      waLink(waNum),
                    target:    '_blank',
                    rel:       'noopener',
                    className: 'promo-detail__btn promo-detail__btn--primary',
                    innerHTML: uiIcons.whatsapp + ' Contactar por WhatsApp' })
                : null,
            business
                ? h('a', {
                    href:      `/negocio/${promo.businessId}`,
                    className: 'promo-detail__btn promo-detail__btn--outline'
                }, 'Ver negocio completo →')
                : null
        )
    )

    return h('div', { className: 'page' },
        c('Header'),
        h('div', { className: 'promo-detail-page' },
            h('div', { className: 'promo-detail__inner' },
                h('a', { href: '/promociones', className: 'promo-detail__back' }, '← Volver a promociones'),
                h('div', { className: 'promo-detail__card' },
                    heroSection,
                    body,
                    socialBar
                ),
                cta
            )
        )
    )
})
